import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IPaymentWithLinkedRequest {
  bankCode: string;
  orderId: string;
  merchantId: number;
  amount: string;
  installmentCount: string;
  description: string;
  currency: string;
  receiverEmail: string;
  receiverPhoneNumber: string;
  expireMinute: number;
  memberId: number;
  lınkPaymentCount: number;
  okUrl: string;
  failUrl: string;
  payerNote?: string;
}

async function paymentWithLinked(
  data: IPaymentWithLinkedRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Payment/CreateLinkPayment", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any);
  }
}

export function usePaymentWithLinked() {
  return useMutation<any, Error, IPaymentWithLinkedRequest>((variables) =>
    paymentWithLinked(variables)
  );
}
